import { useState, useEffect, useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';

export const useCustomerInfo = () => {
  const { customer } = useContext(ExperienceContext);
  const [customerInfo, setCustomerInfo] = useState(() => ({
    svocID: '',
    userID: '',
    customerType: customer.type?.toUpperCase() || '',
  }));

  useEffect(() => {
    setCustomerInfo({
      svocID: window.THDCustomer?.default.svocID || '',
      userID: window.THDCustomer?.default.userID || '',
      customerType: window.THDCustomer?.default.customerType || '',
    });
  }, []);

  return customerInfo;
};
